import React, { Component } from 'react'
import CircularProgress from "@mui/material/CircularProgress"
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'

export default class ImportingModal extends Component {

    render() {
        // console.log('ImportingModal this.props:',this.props)

        if (!this.props.open)
            return null;

        let title = 'Please wait'

        return (
            <Dialog open={Boolean(this.props.open)} onClose={this.props.onHide} maxWidth="sm" fullWidth>
                <DialogTitle>{title}</DialogTitle>
                <DialogContent>
                    <CircularProgress />
                </DialogContent>
            </Dialog>
        )
    }
}
